<template>
    <div class="radio" :class="[{ disabled }, { inline }, { invalid: error }]">
        <label :for="id" :class="{ active }">
            <input type="radio"
                   :name="id"
                   :id="id"
                   :value="value"
                   :disabled="disabled"
                   @change="onChange"
                   :checked="active" />
            <span class="circle"></span>
            <slot></slot>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'Radio',
        model: {
            prop: 'modelValue',
            event: 'input'
        },
        props: {
            id: String,
            value: {
                default: ''
            },
            disabled: Boolean,
            inline: Boolean,
            modelValue: {
                default: undefined
            },
            error: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.$emit('input', this.modelValue);
        },
        computed: {
            active() {
                return this.modelValue === this.value;
            }
        },
        methods: {
            onChange() {
                this.$emit('input', this.value);
                this.$emit('change', this.value);
            }
        }
    };
</script>
